export default __webpack_public_path__ + "newsletter-form.png";